import * as types from '../actionTypes/ActionTypes';
// INIT
const initialState = {
  data: [],
};

const RoleReducers = (state = initialState, action) => {
  switch (action.type) {
    case types.ROLE_ACTIONS_TYPE.GET_ROLE_ACTION_SUCCESS:
      return {
        data: action.payload,
      };
    default:
      return state;
  }
};

export default RoleReducers;
